import Window from "../Window/Window"
import styles from "./AboutMeWindow.module.css"
import { translations } from "../../translations"
import { useTranslationUpdate } from "../../hooks/useTranslationUpdate"
import SkillsSection from "./SkillsSection"
import EducationSection from "./EducationSection"
import LanguagesSection from "./LanguagesSection"
import InterestsSection from "./InterestsSection"
import IntroductionSection from "./IntroductionSection"

type Props = {
    onClose: () => void
    isMinimized: boolean
    onToggleMinimize: () => void
    fullName?: string
    roleLine?: string
}

export default function AboutMeWindow({
    onClose,
    isMinimized,
    onToggleMinimize,
    fullName = "Evelyn Porto",
}: Props) {
    useTranslationUpdate()

    if (isMinimized) return null

    return (
        <Window
            title={translations('about_me.title')}
            onClose={onClose}
            isMinimized={isMinimized}
            onToggleMinimize={onToggleMinimize}
            initialPosition={{ x: window.innerWidth / 2 - 420, y: 60 }}
            initialSize={{ width: 840, height: 620 }}
            minSize={{ width: 560, height: 420 }}
            bodyClassName={styles.body}
            containerClassName={styles.poppinsAll}
        >
            <div className={styles.headerBand}>
                <div className={styles.profileRow}>
                    <div className={styles.avatarWrap}>
                        <img src="/images/avatar.png" className={styles.avatar} alt="Profile avatar" />
                    </div>
                    <div className={styles.identity}>
                        <h1 className={styles.name}>{fullName}</h1>
                        <div className={styles.role}>
                            <img src="/images/icons/computer.svg" className={styles.iconSmall} alt="" />
                            <span>{translations('about_me.role_line')}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.sectionGrid}>
                <IntroductionSection />
                <SkillsSection />
                <EducationSection />
                <LanguagesSection />
                <InterestsSection />
            </div>
        </Window>
    )
}